import { getItem, localStorageExists } from 'owa-local-storage';
import { CLIENT_CONFIGURATION_COMBINED_FAVORITES_KEY } from '../favoriteConstants';
import { isMonarchMultipleAccountsEnabled } from 'owa-account-source-list';

const doesCombinedFavoritesExistInCache = (): boolean => {
    if (!localStorageExists(window) || !isMonarchMultipleAccountsEnabled()) {
        return false;
    }
    return !!getItem(window, CLIENT_CONFIGURATION_COMBINED_FAVORITES_KEY);
};

export default doesCombinedFavoritesExistInCache;
